import React from "react";
import CountryManagementTable from "./CountryManagementTable";

const CountryManagement = () => {

  return <div>{<CountryManagementTable />}</div>;
};

export default CountryManagement;
